import { vehicleTypesCategoryId } from './common';

export const home = '/';

// user
export const user = '/user';
export const userLogin = `${user}/login`;
export const userInspectionRequests = `${user}/inspection-requests`;
export const userBatteryRequests = `${user}/battery-requests`;
export const userOrders = `${user}/orders`;
export const userOrderChangePayment = (orderId: string, subOrderId: string, changeId: string) =>
    `${userOrders}/${orderId}/sub-orders/${subOrderId}/changes/${changeId}/payment`;
export const userReviews = `${user}/reviews`;
export const userVehiclePlates = `${user}/vehicle-plates`;
export const userProfile = `${user}/profile`;
export const userWallet = `${user}/profile/wallet`;
export const userInquiry = `${user}/inquiry`;

// request
export const requestReservation = '/reservation';
export const requestAddress = '/address';
export const requestExtraService = '/extra-services';
export const requestPayment = '/payment';

// battery
export const batteryRequest = '/battery-request';

// inspection
export const inspectionRequest = '/inspection-request';

// motor inspection
export const motorInspection = '/motor-inspection';
export const motorInspectionRequest = `${motorInspection}${inspectionRequest}`;

// car inspection
export const carInspection = '/car-inspection';
export const carInspectionRequest = `${carInspection}${inspectionRequest}`;

// car buying assistant
export const carBuyingAssistant = '/car-buying-assistant';

// motor buying assistant
export const motorBuyingAssistant = '/motor-buying-assistant';

// vehicle fines
export const vehicleFinesLanding = '/vehicle-fines';
export const vehicleFinesByMotorCycleLanding = '/vehicle-fines?vehicle-type=' + vehicleTypesCategoryId.MOTORCYCLE;
export const vehicleFinesInquiry = '/vehicle-fines/inquiry';
export const vehicleFinesResult = '/vehicle-fines/result';
export const vehicleFinesPaymentInfo = '/payment-info';

// freeway tolls
export const freewayTolls = '/freeway-tolls';

// traffic plan
export const trafficPlanLanding = '/traffic-plan';
export const trafficPlanInquiry = '/traffic-plan/inquiry';

// freeway tolls
export const freewayTollsLanding = '/freeway-tolls';
export const freewayTollsInquiry = '/freeway-tolls/inquiry';

// battery product
export const carBatteryLanding = '/car-battery';
export const motorBatteryLanding = '/motor-battery';

// engine oil product
export const carEngineOilLanding = '/car-engine-oil';
export const motorEngineOilLanding = '/motor-engine-oil';

// brands
export const brandLanding = '/brand';
export const vehicleModelBatteryLanding = '/vehicle/battery';

// campaigns landing
export const yaldaGameLanding = '/yalda-game';
export const batteryToBatteryCampaignLanding = '/battery-to-battery';
export const couponCodeLanding = '/landing/park-coupon-code';

// app download
export const appDownloadPage = '/download-app';

// strapi landing page
export const strapiLandingPage = '/landing';

// service pages
export const servicePage = '/service';

// checkout pages
export const checkoutShippingPage = '/checkout/shipping';
export const checkoutCartPage = '/checkout/cart';
export const checkoutPaymentPage = '/checkout/payment';

// vendor
export const vendorLanding = '/vendor';
export const vendorStores = `${vendorLanding}/stores`;
